var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-size",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7528_152756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1429 15.5715V19.8572C19.1429 20.2361 18.9924 20.5994 18.7245 20.8673C18.4566 21.1353 18.0932 21.2858 17.7144 21.2858H4.14293C3.76405 21.2858 3.40068 21.1353 3.13277 20.8673C2.86487 20.5994 2.71436 20.2361 2.71436 19.8572V6.28577C2.71436 5.90689 2.86487 5.54352 3.13277 5.27561C3.40068 5.0077 3.76405 4.8572 4.14293 4.8572H8.42864M12.7144 14.8572L8.42864 15.6286L9.14293 11.2858L17.3286 3.12862C17.4614 2.99473 17.6194 2.88845 17.7935 2.81592C17.9676 2.74339 18.1543 2.70605 18.3429 2.70605C18.5315 2.70605 18.7182 2.74339 18.8923 2.81592C19.0664 2.88845 19.2244 2.99473 19.3572 3.12862L20.8715 4.64291C21.0054 4.77571 21.1117 4.93372 21.1842 5.1078C21.2567 5.28188 21.2941 5.46861 21.2941 5.6572C21.2941 5.84578 21.2567 6.03251 21.1842 6.20659C21.1117 6.38067 21.0054 6.53868 20.8715 6.67148L12.7144 14.8572Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7528_152756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.32879b51070cb76239a0b97d31a2ffee.svg";
export { ForwardRef as ReactComponent };